import { PurchaseActionOption } from "common";
import { RefundOption, RefundSelectOption } from "@/components/Dashboard/RefundOption";

interface GetNextPurchaseModificationActionsProps {
    balance: number;
    hasPurchaseChanges: boolean;
    hasCustomerEmail: boolean;
    canViewInvoice: boolean;
    refundAmount: number;
    refundSelection?: RefundSelectOption | null;
}

interface NextPurchaseModificationActions {
    nextModalOption: PurchaseActionOption | null;
    nextRefundOption: RefundOption | null;
}

export const getNextPurchaseModificationActions = ({
    balance,
    hasPurchaseChanges,
    hasCustomerEmail,
    canViewInvoice,
    refundAmount,
    refundSelection,
}: GetNextPurchaseModificationActionsProps): NextPurchaseModificationActions => {
    const nextModal =
        canViewInvoice && hasCustomerEmail
            ? PurchaseActionOption.COLLECT_BALANCE_OPTIONS
            : PurchaseActionOption.COLLECT_BALANCE;
    const isRefundSuppressed = refundSelection === RefundSelectOption.NONE;

    return {
        nextModalOption: balance > 0 && hasPurchaseChanges ? nextModal : null,
        nextRefundOption:
            refundAmount < 0 && hasPurchaseChanges && !isRefundSuppressed ? RefundOption.RETURN_PAYMENT : null,
    };
};
